module.exports = __webpack_public_path__ + "img/ai.ecadc26a.png";